import { twMerge } from "tailwind-merge";

interface Props {
  children: React.ReactNode;
  status: React.ReactNode;
  duration?: React.ReactNode;
  className?: string;
  info?: React.ReactNode;
  count?: React.ReactNode;
}

/** @deprecated Use `~/components/build/Show/pages/steps/list/components/TreeNode/Label` instead. */
export const Label = ({ children, className, status, duration, info, count }: Props) => {
  return (
    <>
      <div
        className={twMerge(
          "text-charcoal-700 flex h-7 min-w-0 flex-auto items-center py-1 text-left",
          className,
        )}
      >
        <div className="w-full max-w-full space-x-2 truncate font-medium group-hover/link:opacity-100 group-aria-[current=step]:opacity-100 group-data-[step-state='waiting_for_dependencies']/link:opacity-45 group-data-[step-state=ignored]/link:opacity-45">
          {children}
        </div>
      </div>

      {info && <span className="mr-0.5 shrink-0">{info}</span>}

      <div className="flex shrink-0 items-center justify-center gap-1 self-stretch text-xs">
        {duration}
        {count}
        {status}
      </div>
    </>
  );
};
